import useTranslations from "@/shared/lang/useTranslations";
import { cn } from "@/shared/lib/utils";

import { useBatchExpiry } from "../../hooks/useBatchExpiry";

export interface BatchExpiryCountdownProps {
  expiresAt: string | null;
  className?: string;
}

/** "Expires in HH:MM:SS" under a batch awaiting confirmation; amber during the last hour. */
export function BatchExpiryCountdown({ expiresAt, className }: BatchExpiryCountdownProps) {
  const { t } = useTranslations("payoutBatches");
  const expiry = useBatchExpiry(expiresAt);
  if (!expiresAt || expiry.isExpired) return null;
  return (
    <span
      className={cn(
        "font-mono text-[11px] tabular-nums",
        expiry.isClosing ? "text-warning" : "text-muted-foreground",
        className,
      )}
    >
      {t("list_expires_in", { time: expiry.formatted })}
    </span>
  );
}
